import { Component, ViewEncapsulation } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-aquila-sidebar-aquila-code",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./sidebar-aquila-code.component.svg",
  styleUrl: "./sidebar-aquila-code.component.css",
  encapsulation: ViewEncapsulation.Emulated,
})
export class SidebarAquilaCodeComponent {}
